export default "__VITE_ASSET__bxlYAWLb__"